import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
overflow-x: hidden;
overflow-y: hidden;
`

export const AbsoluteContentContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  box-sizing: border-box;
  padding: 101px 46px 0px 46px;
`

export const ContentContainer = styled.div`
  flex: 1;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);
  background-color: ${C.WHITE};
  overflow-x: hidden;
  overflow-y: hidden;
  transition: height 0.4s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  width: 100%;
`